import APIService from '.';

export default class FlagsService extends APIService {
  getOptions(oauthId: string) {
    return this.get(`/merchant-connect/oauth/${oauthId}/settings`);
  }

  changeStatus(oauthId: string, data: any) {
    return this.put(`/merchant-connect/oauth/${oauthId}/settings`, data);
  }
}
